export default __webpack_public_path__ + "static/media/empty-state.e5e1892d.svg";